export default __webpack_public_path__ + "static/media/service-management.7fd9f0eb.svg";